import { getToken } from '../Context/User.context';
import API from './index';

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

/** Instances de checklist d'un jour (format YYYY-MM-DD, heure locale). */
export const getInstancesByDate = (date: string) =>
  API.get(`/checklist/instance?date=${date}`, { headers: authHeaders() });

/** Détail d'une instance (points + état). */
export const getInstance = (id: number) =>
  API.get(`/checklist/instance/${id}`, { headers: authHeaders() });

/**
 * Modifie un point : 'valid' (vert), 'invalid' (rouge) ou null
 * (non renseigné). L'API enregistre l'email et l'horodatage.
 */
export const updateItem = (instanceId: number, itemId: number, status: 'valid' | 'invalid' | null) =>
  API.patch(`/checklist/instance/${instanceId}/item/${itemId}`, { status }, { headers: authHeaders() });
